﻿import React from 'react';
import classNames from 'classnames';
import { Switch, Alignment } from "@blueprintjs/core";
import PropTypes from 'prop-types';
import { ShowHide } from 'components/layout';

import { FormHelperText, FormHeading } from "components/form-fields";

import 'components/form-fields/FormFields.css';

export function FormSwitch(
    {
        id = null,
        checked = false,
        loading = false,
        inline = false,
        label = "",
        headingText = "",
        helperText = null,
        disabled = false,
        dangerHelperText = null,
        alignment = Alignment.START,
        showLabels = true,
        checkedLabel = "On",
        uncheckedLabel = "Off",
        labelElement = null,
        identifier,
        onChange
    }
) {

	return (
        <div className={classNames("form-field form-field-switcher", { "no-label": !label })}>
            <FormHeading loading={loading} headingLevel={"h4"}>{headingText}</FormHeading>
            <ShowHide
				evaluator={!inline}
				show={(
					<label className={classNames({ "bp6-skeleton": loading })} htmlFor={identifier}>{label}</label>
				)}
			/>
            <FormHelperText loading={loading}>{helperText}</FormHelperText>
            <Switch
				id={id}
				identifier={identifier}
				disabled={disabled}
				className={classNames({ "bp6-skeleton": loading })}
				label={inline ? label : ""}
				alignIndicator={alignment}
				onChange={onChange}
				checked={checked}
				innerLabelChecked={showLabels ? checkedLabel : ""}
				innerLabel={showLabels ? uncheckedLabel : ""}
				labelElement={labelElement}
			/>
            <FormHelperText loading={loading} danger={true}>{dangerHelperText}</FormHelperText>
        </div>
    );
}

FormSwitch.propTypes = {
	id: PropTypes.string,
	checked: PropTypes.bool,
	label: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	loading: PropTypes.bool,
	inline: PropTypes.bool,
	headingText: PropTypes.string,
	helperText: PropTypes.node,
	disabled: PropTypes.bool,
	dangerHelperText: PropTypes.node,
	alignment: PropTypes.string,
	showLabels: PropTypes.bool,
	checkedLabel: PropTypes.string,
	uncheckedLabel: PropTypes.string,
	labelElement: PropTypes.node
};